import { Component, ElementRef, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RiskControl } from 'src/app/core/models/riskControl/riskControl';
import { riskControlService } from 'src/app/core/services/riskControl/risk-control.service';
import { AddEditRiskControlsComponent } from '../add-edit-risk-controls/add-edit-risk-controls.component';
import { ItemActiveModel } from 'src/app/core/models/view-model/item-acive-model';
import { RiskControlViewModal } from 'src/app/core/models/view-model/risk-control-view.modal';
import { MasterHelper } from 'src/app/core/utilities';
import { RiskControlFilter, riskControlDropdownDto, riskcontrolfiltersaveDto } from 'src/app/core/models/riskControl/riskControl-filter';
import { DeleteDialogComponent } from '../distributed-ui-components';
import { AlertDialogModel, ToastViewModel } from 'src/app/core/models/view-model';
import { RiskControlDto } from 'src/app/core/models/riskControl/riskControlDto';
import { debug } from 'console';

@Component({
  selector: 'app-risk-controls',
  templateUrl: './risk-controls.component.html',
  styleUrls: ['./risk-controls.component.scss']
})
export class RiskControlsComponent implements OnInit {
  
  isToastShow = false;
  toastModel: ToastViewModel;
  isLoadingRiskControl = false;
  riskControl :Array<RiskControl>;
  tableWidth!: number;
  riskControlFilterListArray:RiskControlDto[]=[];
  riskControlListArray:RiskControlDto[]=[];
  riskrefList :riskControlDropdownDto[]=[];
  inherentRiskRatingList:riskControlDropdownDto[]=[];
  residualRiskRatingList:riskControlDropdownDto[]=[];
  riskAreaList :riskControlDropdownDto[]=[];
  riskCategoryList:riskControlDropdownDto[]=[];
  riskTitleList:riskControlDropdownDto[]=[];
  complianceTopicList:riskControlDropdownDto[]=[];
  entitiesImpactedList:riskControlDropdownDto[]=[];
  residualRiskControlStrength:riskControlDropdownDto[]=[];
  inherentRiskImpactList:riskControlDropdownDto[]=[];
  inherentRiskLikelihoodList:riskControlDropdownDto[]=[];
  riskOwnerList:riskControlDropdownDto[]=[];
  riskStatusList:riskControlDropdownDto[]=[];
  approvalStatusList:riskControlDropdownDto[]=[];
  riskAccountabilityOwnerList :riskControlDropdownDto[]=[];
  riskApproverList:riskControlDropdownDto[]=[];
  riskDescriptionList:riskControlDropdownDto[]=[];
  applicableRulesList:riskControlDropdownDto[]=[];
  filterriskRef!: riskControlDropdownDto[];
  filterriskArea!: riskControlDropdownDto[];
  filterriskCategory!: riskControlDropdownDto[];
  filterriskTitle!: riskControlDropdownDto[];
  filtercomplianceTopic!: riskControlDropdownDto[];
  filterentitiesImpacted!: riskControlDropdownDto[];
  filterriskOwner!: riskControlDropdownDto[];
  filterriskDescription!: riskControlDropdownDto[];
  filterapplicableRules!: riskControlDropdownDto[];
  riskfilterRef!: riskControlDropdownDto[];
  inherentfilterRiskRatingList!:riskControlDropdownDto[];
  residualfilterRiskRatingList!:riskControlDropdownDto[];
  riskfilterArea!: riskControlDropdownDto[];
  riskfilterCategory!: riskControlDropdownDto[];
  riskfilterTitle!: riskControlDropdownDto[];
  sidebarVisible: boolean = false;
 compliancefilterTopic!: riskControlDropdownDto[];
  entitiesfilterImpacted!: riskControlDropdownDto[];
  riskfilterOwner!: riskControlDropdownDto[];
  riskfilterDescription!: riskControlDropdownDto[];
  applicablefilterRules!: riskControlDropdownDto[];
  alertDialogModel: AlertDialogModel;
  assesmentType = '_riskControl';
  riskFilter :RiskControlFilter;
  riskControlViewModal :RiskControlViewModal;
  riskControlActiveModel: Array<ItemActiveModel>;
  myInnerHeight: any;
  classTableHead: string =
  'table-responsive scheduler_table_main box-shadow table-cont';
 selectedRiskControlIds: Array<number>;
 selectedRiskControl:Array<RiskControl>

  constructor(
    private riskcontrolService :riskControlService,
    private eleRef: ElementRef,
    
    public dialog: MatDialog,
  ){
    this.alertDialogModel = new AlertDialogModel();
    this.toastModel = new ToastViewModel();
    this.riskControlActiveModel = [
      { itemTitle: 'Effective Date', itemWidth: 120, isActive: true },
      { itemTitle: 'Risk Ref', itemWidth: 300, isActive: true },
      { itemTitle: 'Risk Area', itemWidth: 120, isActive: true },
      { itemTitle: 'Risk Category', itemWidth: 150, isActive: true },
      { itemTitle: 'Risk Title date', itemWidth: 150, isActive: true },
      { itemTitle: 'Compliance Topic date', itemWidth: 220, isActive: true },
      { itemTitle: 'Entities Impacted to', itemWidth: 220, isActive: true },
      { itemTitle: 'Owner', itemWidth: 80, isActive: true },
      {itemTitle: 'Inherent Rating',itemWidth:80 ,isActive:true},
      {itemTitle: 'Residual Risk',itemWidth:80 ,isActive:true},
     
    ];
    this.riskControlViewModal =  new RiskControlViewModal;
    this.selectedRiskControlIds = [];
    this.myInnerHeight = window.innerHeight - 190;
  this.riskFilter = new RiskControlFilter;
    this.selectedRiskControl = [];
    this.riskControl =[];
  }
  ngOnInit(): void {
    
    this.isLoadingRiskControl = true;
    this.fetchRiskControl(this.riskFilter);
    this.getDropwdownList();
      const persistColumn = JSON.parse(
        this.fetchFromBrowser(this.assesmentType) as string
      ) as ItemActiveModel[];
      if (persistColumn) {
        this.riskControlActiveModel = persistColumn;
      }
      this.eleRef.nativeElement.style.setProperty(
        '--table-min-width',
        this.tableWidth + 'px'
      );
      this.riskControlActiveModel.forEach((element) => {
        this.showHideColumn(
          element.itemTitle,
          element.itemWidth,
          element.isActive,
          'OnLoad'
        );
      });
  }
  totalCountWithoutFilter:number=0;
  fetchRiskControl(dataFilter: RiskControlFilter){
    
    this.riskcontrolService.getRiskControl(dataFilter).subscribe((data:any)=>{
      
      this.riskControl = data.data;
      this.riskControlListArray=data.data;
      this.totalCountWithoutFilter = data.TotalCountWithoutFilter;
      this.isLoadingRiskControl = false
    });
  }
  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }
  openDeleteDialog(id:number): void {
    this.alertDialogModel.HeadingText = 'Delete Item';
    this.alertDialogModel.BodyText = 'Are you sure you want to delete this?';
    this.alertDialogModel.ActionButtonText = 'Delete';
    this.alertDialogModel.IsAction = true;

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '450px',
      data: this.alertDialogModel,
    });
    dialogRef.afterClosed().subscribe((result) => {
      
      if (result === 'Delete Item') {
      
        this.deleteRiskControl(id);
      }
    });
  }
  deleteRiskControl(id:number){
    this.riskcontrolService.deleteRiskControl(id).subscribe((data:any)=>{
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = 'Data deleted successfully';
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 5000);
      this.fetchRiskControl(this.riskFilter);
    });
  }
 openEditModal(item:RiskControl){
  
  let dialogRef = this.dialog.open(AddEditRiskControlsComponent,{
    height: 'auto',
      width: '1250px',
      data: {
        Data :item,
        isCreate: false,
      },
  });
  dialogRef.afterClosed().subscribe((result) => {
    
    if (result.edited) {
      this.saveAlertMessage(true, 'Data Updated Successfully');
      setTimeout(() => { }, 1000);
      this.fetchRiskControl(this.riskFilter);
    //  this.saveSchedulerItem(result.object);
    }
    else{
      this.saveAlertMessage(false, 'Blank data cannot be saved');
      setTimeout(() => { }, 1000);
      this.fetchRiskControl(this.riskFilter);
    }
  });
 }
 showHideColumn(
  item: string,
  itemWidth: number,
  isHide: boolean,
  filter: string
): void {
  switch (item) {
    case 'Effective Date':
      this.riskControlViewModal.effectiveDate= isHide;
      break;
    case 'Risk Ref':
      this.riskControlViewModal.riskRef = isHide;
      break;
    case 'Risk Area':
      this.riskControlViewModal.riskArea = isHide;
      break;
    case 'Risk Category':
      this.riskControlViewModal.riskCategory = isHide;
      break;

    case 'Risk Title date':
      this.riskControlViewModal.riskTitledate = isHide;
      break;
    case 'Compliance Topic date':
      this.riskControlViewModal.complianceTopicdate = isHide;
      break;
    case 'Entities Impacted to':
      this.riskControlViewModal.entitiesImpactedto = isHide;
      break;
    case 'Owner':
      this.riskControlViewModal.owner = isHide;
      break;
      case 'Inherent Rating':
      this.riskControlViewModal.inherentRating = isHide;
      break;
      case 'Residual Risk':
        this.riskControlViewModal.residualRisk = isHide;
        break;
   
  }

  // if (filter === 'Change') {
  //   this.tableWidth = isHide ? this.tableWidth + itemWidth : this.tableWidth - itemWidth;
  // } else if (!isHide) {
  //   this.tableWidth = isHide ? this.tableWidth + itemWidth : this.tableWidth - itemWidth;
  // }
  //this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');

  if (filter === 'Change') {
    if (isHide) {
      this.tableWidth = this.tableWidth + itemWidth;
      this.eleRef.nativeElement.style.setProperty(
        '--table-min-width',
        this.tableWidth + 'px'
      );
    } else if (!isHide) {
      this.tableWidth = this.tableWidth - itemWidth;
      this.eleRef.nativeElement.style.setProperty(
        '--table-min-width',
        this.tableWidth + 'px'
      );
    }
  }
  MasterHelper.saveOnBrowser(
    this.assesmentType,
    JSON.stringify(this.riskControlActiveModel)
  );
}
 openCreateModal(){
  let dialogRef = this.dialog.open(AddEditRiskControlsComponent,{
    height: 'auto',
      width: '1250px',
      data: {
        Data : null,
        isCreate: true,
      },
  });
  dialogRef.afterClosed().subscribe((result) => {
    
    if (result.edited) {
      
      this.fetchRiskControl(this.riskFilter);
      this.saveAlertMessage(true, 'Data Save Successfully');
      setTimeout(() => { }, 1000);
    
    //  this.saveSchedulerItem(result.object);
    }else{
          this.saveAlertMessage(false, 'Blank data cannot be saved');
    setTimeout(() => { }, 1000);
    this.fetchRiskControl(this.riskFilter);
    }
  });
  
 }
 saveAlertMessage(isStatusTrue: boolean, message: string) {
  if (isStatusTrue) {
    this.toastModel.Title = 'Success';
    this.toastModel.Type = 'success';
  } else {
    this.toastModel.Title = 'Warning';
    this.toastModel.Type = 'warning';
  }
  this.toastModel.Message = message;
  this.isToastShow = true;
  setTimeout(() => {
    this.isToastShow = false;
  }, 3500);
}
 filterPropertyValues<T>(array: T[], propertyName: keyof T) {
  let filterObjectList = this.mapPropertyValues(array, propertyName);
  return this.dropdownArrayFilterFn(filterObjectList);
}
mapPropertyValues<T>(array: T[], propertyName: keyof T): Array<T[keyof T]> {
  return array.map((obj) => obj[propertyName]);
}
dropdownArrayFilterFn(arrayDropdown: any[]) {
  const distinctObjectsArray = arrayDropdown.reduce(
    (accumulator, innerArray) => {
      innerArray.forEach((obj: riskControlDropdownDto) => {
        const existingObj = accumulator.find(
          (item: riskControlDropdownDto) => item.item === obj.item
        );
        if (!existingObj) {
          accumulator.push(obj);
        }
      });
      return accumulator;
    },
    []
  );
  return distinctObjectsArray;
}
getDropwdownList() {
  this.riskcontrolService.getAllDropdownList().subscribe((res) => {
    
    for (let object of res.result) {
      if(object.filterTypeId==1){
        this.riskAreaList.push(object);
      }
      if(object.filterTypeId ==2){
        this.complianceTopicList.push(object);
      }
      if(object.filterTypeId ==3){
        this.riskCategoryList.push(object)
      }
      if(object.filterTypeId ==4){
        this.riskTitleList.push(object);
      }
      if(object.filterTypeId ==5){
        this.riskOwnerList.push(object);
      }
      if(object.filterTypeId ==6){
        this.riskAccountabilityOwnerList.push(object);
      }
      if(object.filterTypeId ==7){
        this.riskApproverList.push(object);
      }
      if(object.filterTypeId ==8){
        this.approvalStatusList.push(object);
      }
      if(object.filterTypeId ==9){
        this.riskStatusList.push(object);
      }
      if(object.filterTypeId ==10){
        this.entitiesImpactedList.push(object);
      }
      if(object.filterTypeId ==11){
        this.inherentRiskLikelihoodList.push(object);
      }
      if(object.filterTypeId ==12){
        this.inherentRiskImpactList.push(object);
      }
      if(object.filterTypeId ==13){
        this.residualRiskControlStrength.push(object);
      }
    }
    const items: riskControlDropdownDto[] = [
      {
        id: '1',
        item: 'very low',
        icon: 'icon-path-1.png',
        classStyle: 'style-class-1'
      },
      {
        id: '2',
        item: 'low',
        icon: 'icon-path-2.png',
        classStyle: 'style-class-2'
      },
      {
        id: '3',
        item: 'moderate',
        icon: 'icon-path-3.png',
        classStyle: 'style-class-3'
      },
      {
        id: '4',
        item: 'high',
        icon: 'icon-path-4.png',
        classStyle: 'style-class-4'
      },
      {
        id: '5',
        item: 'very high',
        icon: 'icon-path-5.png',
        classStyle: 'style-class-5'
      }
    ];
    this.inherentRiskRatingList = items;
    this.residualRiskRatingList = items;
    this.riskAreaList;
  });

}
 resetFilters() {
  this.riskfilterCategory;
   // this.filterapplicableRules = this.filterPropertyValues(
  //   this.riskControlFilterListArray,
  //   'applicableRules'
  // );
  // this.filtercomplianceTopic = this.filterPropertyValues(
  //   this.riskControlFilterListArray,
  //   'complianceTopic'
  // );
  // this.filterentitiesImpacted = this.filterPropertyValues(
  //   this.riskControlFilterListArray,
  //   'entitiesImpacted'
  // );
  // this.filterriskArea = this.filterPropertyValues(
  //   this.riskControlFilterListArray,
  //   'riskArea'
  // );
  // this.filterriskCategory = this.filterPropertyValues(
  //   this.riskControlFilterListArray,
  //   'riskCategory'
  // );
  // this.filterriskDescription = this.filterPropertyValues(
  //   this.riskControlFilterListArray,
  //   'riskDescription'
  // );
  // this.filterriskOwner = this.filterPropertyValues(
  //   this.riskControlFilterListArray,
  //   'riskOwner'
  // );
  // this.filterriskRef = this.filterPropertyValues(
  //   this.riskControlFilterListArray,
  //   'riskRef'
  // );
  // this.filterriskTitle = this.filterPropertyValues(
  //   this.riskControlFilterListArray,
  //   'riskTitle'
  // );
  this.sidebarVisible = !this.sidebarVisible;
}
closeFilterBar(resultData: riskcontrolfiltersaveDto) {
  
  if (resultData) {
    this.riskfilterArea = resultData.riskArea;
    this.riskfilterCategory = resultData.riskCategory;
    this.riskfilterDescription = resultData.riskDescription;
    this.riskfilterOwner = resultData.riskOwner;
    this.riskfilterRef = resultData.riskRef;
    this.riskfilterTitle = resultData.riskTitle;
    this.compliancefilterTopic = resultData.complianceTopic;
    this.entitiesfilterImpacted = resultData.entitiesImpacted;
    this.applicablefilterRules = resultData.applicableRules;
    this.inherentfilterRiskRatingList =resultData.inherentRiskRatingList;
    this.residualfilterRiskRatingList=resultData.residualRiskRatingList;
    resultData.result.pageIndex=1;
    resultData.result.pageSize=10;
    this.fetchRiskControl(resultData.result);
  } else {
    this.fetchRiskControl(this.riskFilter);
  }
 this.sidebarVisible = !this.sidebarVisible;
}
scrollTop: number = 0;
scrollLeft: number = 0;
onScroll(event: any) {
  
  const target = event.target;
  const prevScrollTop = this.scrollTop || 0;
  const prevScrollLeft = this.scrollLeft || 0;
  const scrollTop = target.scrollTop;
  const scrollLeft = target.scrollLeft;
  const isVerticalScroll = scrollTop !== prevScrollTop;
  const isHorizontalScroll = scrollLeft !== prevScrollLeft;
  if (isVerticalScroll && !isHorizontalScroll) {
    const tableViewHeight = target.offsetHeight;
    const tableScrollHeight = target.scrollHeight;
    const scrollLocation = target.scrollTop;
    
    if ((this.totalCountWithoutFilter > this.riskControlFilterListArray.length)&&(tableScrollHeight - scrollLocation - tableViewHeight <= 50)) {
      this.riskFilter.pageIndex++;
      
      this.fetchRiskControl(this.riskFilter);
    }
  }
  this.scrollTop = scrollTop;
  this.scrollLeft = scrollLeft;
}
}
